/**
 * User Menu — avatar dropdown with identity and the version badge.
 *
 * AXF-1013: there is no sign-out here any more. Sign-out belongs to the app that owns the sign-in,
 * and the portal has none — a staff member signs out in AX WorkFlow, which ends this session too
 * because both read the same cookie. Keeping a sign-out here would mean the portal could end a
 * customer-surface session, which is the crossover this ticket exists to close (spec C2, R9).
 */
import { Avatar, Dropdown, Space, Typography } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import { authStore } from '@store/authStore'
import { useVersionQuery } from '@queries/version'
import { ROUTES } from '@shared/constants'

const { Text } = Typography

export function UserMenu() {
  const { user } = useSnapshot(authStore)
  const navigate = useNavigate()
  const { data } = useVersionQuery()

  const versionLabel = data
    ? `v${data.version}${data.buildSha ? ` · ${data.buildSha.slice(0, 7)}` : ''}`
    : null

  const items = [
    {
      key: 'user-info',
      label: (
        <div style={{ padding: '4px 0' }}>
          <Text strong>{user?.displayName}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: 12 }}>{user?.email}</Text>
        </div>
      ),
      disabled: true,
    },
    ...(versionLabel
      ? [
          { type: 'divider' as const },
          {
            key: 'whats-new',
            label: (
              <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: 11 }}>
                {versionLabel} →
              </span>
            ),
            onClick: () => navigate(ROUTES.WHATS_NEW),
          },
        ]
      : []),
  ]

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Space style={{ cursor: 'pointer' }}>
        <Avatar
          size="small"
          icon={<UserOutlined />}
          src={user?.avatarUrl}
          style={{ backgroundColor: '#00263E' }}
        />
        <Text style={{ maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {user?.displayName}
        </Text>
      </Space>
    </Dropdown>
  )
}

export default UserMenu
